import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './SearchInput.styles';
import Icon from '../../common/icon/Icon';

class SearchInput extends Component {
  render() {
    let { styles: customStyles, placeholder, ...rest } = this.props;
    customStyles = customStyles || {};
    return (
      <div className={css(styles.base, customStyles.base)}>
        <input
          type="text"
          className={css(styles.input, customStyles.input)}
          placeholder={placeholder || I18n.t('data.search')}
          autoFocus
          {...rest}
        />
        <Icon
          value="magnifier"
          styles={[styles.searchIcon, customStyles.icon]}
        />
      </div>
    );
  }
}

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/inputs/searchinput/SearchInput.js